import React from 'react';
import { graphql } from 'gatsby';
import { Section } from '../../Section';
import { Quote as QuoteComponent } from '../../Quote';

export const Quote = ({ data, ...rest }) => (
  <Section contained narrow={data.width === 'narrow'} {...rest}>
    <QuoteComponent {...data} />
  </Section>
);

export const QuoteQuery = graphql`
  fragment Quote on KFH_UmbracoQuoteComponentType {
    quoteText
    quoteName
    position
    company
  }
`;
